import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
    setSelectedBaseLayer
} from '../../../../redux/panel/print/Actions';
import {
    MAIN_MAP
} from '../../../../redux/map/Constants';
import withStyles from '@material-ui/core/styles/withStyles';
import { TextField, Typography, FormControlLabel, Checkbox, Collapse } from '@material-ui/core';

const imageUrl = 'https://landhawk.s3-eu-west-1.amazonaws.com/base-map-icons';
class BaseLayers extends React.Component {
    constructor (props) {
        super(props);
    }

    componentDidMount () {
        const { baseLayer, changeBasemap } = this.props;
        changeBasemap(baseLayer.system_name);
    }

    render () {
        const { classes, basemap, changeBasemap, baseLayers } = this.props;
        return (
            <div className={classes.root}>
                <Typography
                    gutterBottom
                    className={classes.header}
                >
                    Base Layers
                </Typography>
                <div className={classes.baseLayerDropdownRow}>
                    { baseLayers.slice(0, 3).map((l, i) => (
                        <div
                            key={i}
                            className={`${classes.baseLayerDropdownItem}`}
                            onClick={() => changeBasemap(l.system_name)}
                        >
                            <div style={{ backgroundImage: `url('${l.image_url}')` }} className={`${classes.baseLayerDropdownItemImage} ${basemap === l.system_name && classes.selected}`}>
                                <div className={classes.imageOverlay}>
                                    <Typography
                                        variant="subtitle2"
                                        component="div"
                                        color="textPrimary"
                                        className={classes.baseLayerDropdownItemText}
                                    >
                                        {l.name}
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    )) }
                </div>
                <div className={classes.baseLayerDropdownRow}>
                    { baseLayers.slice(3, 6).map((l, i) => (
                        <div
                            key={i}
                            className={`${classes.baseLayerDropdownItem}`}
                            onClick={() => changeBasemap(l.system_name)}
                        >
                            <div style={{ backgroundImage: `url('${l.image_url}')` }} className={`${classes.baseLayerDropdownItemImage} ${basemap === l.system_name && classes.selected}`}>
                                <div className={classes.imageOverlay}>
                                    <Typography
                                        variant="subtitle2"
                                        component="div"
                                        color="textPrimary"
                                        className={classes.baseLayerDropdownItemText}
                                    >
                                        {l.name}
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    )) }
                </div>
            </div>
        );
    }
}

const style = theme => ({
    root: {
        // paddingTop: '10px'
    },
    scrollableContainer: {
        padding: '0 10px'
    },
    subtitle: {
        fontSize: '16px'
    },
    textFieldContainer: {
        paddingTop: '20px'
    },
    header: {
        color: theme.palette.grey.variant5,
        fontSize: '14px'
    },
    cssLabel: {
        color : `${theme.palette.primary.contrastText} !important`
    },
    cssOutlinedInput: {
        '&$cssFocused $notchedOutline': {
            borderColor: `${theme.palette.background.contrastText} !important`
        }
    },
    cssFocused: {},
    notchedOutline: {
        borderWidth: '1px',
        borderColor: `${theme.palette.background.contrastText} !important`
    },
    checkboxLabel: {
        color: `${theme.palette.background.contrastText} !important`
    },
    checkboxContainer: {
        marginLeft: '10px',
        marginTop: '10px'
    },
    checkbox: {
        '&&:hover': {
            backgroundColor: 'transparent'
        }
    },
    dropdownContainer: {
        margin: '0 5px'
    },
    dropdownButton: {
        display: 'flex',
        color: theme.palette.background.contrastText,
        cursor: 'pointer',
        height: '40px',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: `1px solid ${theme.palette.background.contrastText}`
    },
    baseLayerDropdownRow: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingBottom: '10px',
        gridColumnGap: '10px'
    },
    baseLayerDropdownItem: {
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        cursor: 'pointer',
        transition: '0.1s',
        borderRadius: '6px',
        boxSizing: 'border-box'

    },
    baseLayerDropdownItemImage: {
        height: '100px',
        width: '100px',
        margin: '1px',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        borderRadius: '4px',
        border: `1px solid ${theme.palette.grey.variant2}`,
        '&:hover': {
            // color: theme.palette.background.contrastText,
            // border: `1px solid ${theme.palette.background.contrastText}`
            // backgroundColor: theme
            borderColor: '#fff'
        }
    },
    imageOverlay: {
        display: 'grid',
        alignContent: 'end',
        justifyContent: 'start',
        width: '100%',
        height: '100%',
        background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.5) 100%)',
        borderRadius: '4px'
    },
    baseLayerDropdownItemText: {
        paddingLeft: '10px',
        paddingBottom: '5px',
        alignSelf: 'end',
        letterSpacing: '0.4px',
        textShadow: '0 2px 2px rgb(0, 0, 0, 0.25)',
        fontWeight: '500'
    },
    selected: {
        border: `2px solid ${theme.palette.background.contrastText} !important`,
        margin: '0 !important'
    },
    image: {
        objectFit: 'cover',
        opacity: '0.4'
    },
    aerialImage: {
        backgroundImage: `url('${imageUrl}/Map Tile - Satellite.png')`
    },
    lightImage: {
        backgroundImage: `url('${imageUrl}/Map Tile - Light.png')`
    },
    outdoorImage: {
        backgroundImage: `url('${imageUrl}/Map Tile - Outdoor.png')`
    },
    darkImage: {
        backgroundImage: `url('${imageUrl}/Map Tile - Dark.png')`
    },
    roadsImage: {
        backgroundImage: `url('${imageUrl}/Map Tile - Roads.png')`
    },
    mastermapImage: {
        backgroundImage: `url('${imageUrl}/Map Tile - OS MasterMap.png')`
    }
});

const mapStateToProps = state => {
    return {
        baseLayers: state.layers.baseLayers,
        baseLayer: state.layers.baseLayer,
        selectedBaseLayer: state.print_panel.selectedBaseLayer,
        highlights: state.highlights,
        mainMap: state[MAIN_MAP]
    };
};

const mapDispatchToProps = dispatch => ({
    dispatchSetSelectedBaseLayer: (systemName) => dispatch(setSelectedBaseLayer(systemName))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(BaseLayers);